import { pick } from 'lodash';
import useRectProperties from './useRectProperties';

/** @param {DOMRect} rect */
const process = rect => pick(rect, 'width', 'height');

/**
 * @template {HTMLElement} E
 * @param {import('react').MutableRefObject<E>} elementRef
 */
export default function useSize(elementRef) {
    return useRectProperties(elementRef, process);
}